import { NAME } from './constants';
import { menu } from './menu';
import { router } from './router';

export const Uctenky = {
	name: NAME,
	menu,
	router,
};
